import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export interface ILink {
    link_copy: string;
    link_url: string;
}
export interface IRow {
    links: ILink[];
}
export interface IPageComponenQuickLinksData extends NICmsContentComponent.IData {
    title: string;
    quick_links_row: IRow[];
}
@Component({
    selector: 'quick-links',
    templateUrl: 'quick-links.html',
    styleUrls: ['quick-links.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, SizeClassDirective, IfSizeDirective, ICmsClientModule, HrefComponent]
})
@ICmsComponent<QuickLinksComponent>({
    id: 'quick_links_layout',
    name: 'Quick Links Layout',
    tags: ['Quick link', 'Shop trending'],
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'quick_links_row',
            title: 'Qucik Links Row',
            itemName: 'Quick Links Row',
            itemNameField: 'Quick Links Row',
            defaultSize: 1,
            minSize: 1,
            required: true,
            fields: [
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'links',
                    title: 'Links',
                    itemName: 'Link',
                    fields: [
                        <NICmsContentField.IField>{
                            type: NICmsContentField.EFieldType.text,
                            key: 'link_copy',
                            title: 'Link Copy',
                            required: true
                        },
                        <NICmsContentField.IField>{
                            type: NICmsContentField.EFieldType.text,
                            key: 'link_url',
                            title: 'Link URL',
                            required: true
                        }
                    ]
                }
            ]
        }
    ]
})
export class QuickLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: IPageComponenQuickLinksData;
}
